import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface BackToHomeProps {
  className?: string;
  variant?: "button" | "link";
  showIcon?: boolean;
  text?: string;
}

export const BackToHome = ({ 
  className, 
  variant = "button", 
  showIcon = true, 
  text = "Back to Home" 
}: BackToHomeProps) => {
  const content = (
    <>
      {showIcon && <ArrowLeft className="w-4 h-4 mr-2" />}
      {text}
    </>
  );

  if (variant === "link") {
    return (
      <Link 
        to="/" 
        className={cn(
          "inline-flex items-center text-muted-foreground hover:text-foreground transition-colors",
          className
        )}
      >
        {content}
      </Link>
    );
  }

  return (
    <Button variant="ghost" size="sm" asChild className={className}>
      <Link to="/">
        {content}
      </Link>
    </Button>
  );
};